import React from "react";
import { useSelector } from "react-redux";

function useTheme() {

  const isDark = useSelector(({ theme }) => theme.globalTheme === "dark");

  return isDark;
}

export default useTheme;
